<script lang="ts" setup>
definePageMeta({ layout: 'page' })

const { t } = useI18n()

useHead({
  title: t('seo.home.title'),
  meta: [
    {
      name: 'description',
      content: t('seo.home.description'),
    },
    {
      name: 'keywords',
      content: t('seo.home.keywords'),
    },
    {
      property: 'og:title',
      content: t('seo.home.title'),
    },
    {
      property: 'og:description',
      content: t('seo.home.description'),
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:url',
      content: 'https://www.qboson.com/',
    },
    {
      property: 'og:image',
      content: 'https://www.qboson.com/favicon.ico',
    },
    {
      property: 'og:locale',
      content: 'zh_CN',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'twitter:title',
      content: t('seo.home.title'),
    },
    {
      name: 'twitter:description',
      content: t('seo.home.description'),
    },
    {
      name: 'twitter:image',
      content: 'https://www.qboson.com/favicon.ico',
    },
    {
      name: 'author',
      content: '玻色量子',
    },
  ],
})
</script>

<template>
  <AwesomeWelcome />
</template>
